import React from 'react'
import TopNavigation from '../TopNavigation'
import { Container, Row, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import withAppconfig from '../AppContext'
import SaveCard from '../components/Paytrail/SaveCard'

function AddCardScreen({ appconfig }) {
  const { t } = useTranslation()

  return (
    <div className='full-page-background'>
      <TopNavigation title={t('add_card')} />
      <Container className='front'>
        <Row className='text-center' style={{ paddingTop: 20, marginBottom: 30 }}>
          <Col md='8' className='mx-auto'>
            {t('add_card_info')}
          </Col>
        </Row>
        <Row>
          <Col>
            <SaveCard />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default withAppconfig(AddCardScreen)
